import React from 'react';

export const DashboardHeroHeading: React.FC = () => {
  return (
    <section className="pb-10 text-center sm:pb-12">
      <h1 className="mx-auto max-w-5xl text-[2.25rem] font-medium leading-tight text-c-111323 sm:text-[2.8rem] md:text-[3.4rem] lg:text-[3.75rem]">
        See how your agents are performing in real time
      </h1>
    </section>
  );
};
